import moment from 'moment'
import { normalizeToDay } from './normalizers'
import _ from 'lodash'

export function getDays(count) {
  const days = []
  count = count || 7
  const now = moment()
  for (let i = 0; i < count; i++) {
    const delta = moment.duration(i, 'd')
    const day = now.clone().subtract(delta).toDate()
    days.push(normalizeToDay(day.toJSON()))
  }
  return _.reverse(days)
}

export function daysToMs(days = 1) {
  return 1000 * 60 * 60 * 24 * days
}

export function years(yearsPast = 20) {
  const max = new Date().getFullYear()
  const min = max - yearsPast
  const years = []

  for (let i = min; i <= max; i++) {
    years.push(i)
  }

  return years
}
